import {
  Box,
  Button,
  Divider,
  Typography,
} from '@mui/material';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import GenericDialog from '../GenericDialog';
import ContentBox from './ContentBox';

export type Props = {
  display: boolean;
  action: (confirm: boolean) => void;
  title: React.ReactNode;
  maxWidth?: false | 'md' | 'xs' | 'sm' | 'lg' | 'xl' | undefined;
  children: React.ReactNode;
  color?: 'secondary' | 'tertiary',
  language?: 'en'
  alert?: boolean;
  version?: 2;
  okButtonText?: React.ReactNode;
};

const Prompt: React.FC<Props> = ({
  display = false,
  title,
  action,
  children,
  maxWidth,
  color,
  language,
  alert,
  version,
  okButtonText,
}: Props) => (

  <GenericDialog
    isOpen={display}
    onClose={alert ? undefined : () => { action(false); }}
    closeButtonLabel={
      // eslint-disable-next-line no-nested-ternary
      alert ? undefined : (
        language === 'en' ? 'Close' : <FormattedMessage id="genericClose" />
      )
    }
    maxWidth={maxWidth}
    actions={[
      <Button
        key="confirmBtn"
        color={color}
        variant="contained"
        onClick={() => { action(true); }}
      >
        {
          okButtonText && (
            <>
              {okButtonText}
            </>
          )
        }
        { !okButtonText && (
          language === 'en' ? 'Confirm' : <FormattedMessage id="confirm" />
        )}
      </Button>,
    ]}
  >
    {
      version !== 2 && (
        <ContentBox title={title} elevation={0} color={color}>
          <Typography component="div">
            {children}
          </Typography>
        </ContentBox>
      )
    }
    {
      version === 2 && (
        <Box sx={{ px: 1, pt: 1 }}>
          <Box sx={{ m: 2 }}>
            <Typography variant="h5">
              {title}
            </Typography>
          </Box>
          <Box sx={{ mx: 2, my: 3 }}>
            <Typography component="div">{children}</Typography>
          </Box>
          <Divider />
        </Box>
      )
    }
  </GenericDialog>
);

export default Prompt;
